/**
 * attention.ts — клиент ручек «Требует внимания» (WEB-3780, WEB-3784):
 * `GET /projects/:projectId/attention` (WEB-3778) и
 * `GET /organizations/:orgId/attention` (WEB-3779).
 *
 * Сервер отдаёт только виды и числа (без текстов), уже в своём порядке и с
 * масками видимости (кто видит долг, неоплату, суммы); клиент ответ не
 * пересобирает и не дополняет. Отказ сервера уходит той же ошибкой общего
 * обработчика `api/client.ts` (со `status` и `code`).
 *
 * Тип ответа — псевдоним контракта (`generated/schema.ts`), своих объявлений
 * полей здесь нет: расхождение с сервером ловит компилятор.
 */
import { api } from '@/api/client';
import type { operations } from '@/api/generated/schema';

export type ProjectAttention =
  operations['AttentionController_forProject']['responses'][200]['content']['application/json'];

export type OrganizationAttention =
  operations['AttentionOrganizationController_forOrganization']['responses'][200]['content']['application/json'];

export const attentionApi = {
  forProject: async (projectId: string): Promise<ProjectAttention> => {
    const res = await api.get<ProjectAttention>(
      `/projects/${encodeURIComponent(projectId)}/attention`,
    );
    return res.data;
  },

  forOrganization: async (orgId: string): Promise<OrganizationAttention> => {
    const res = await api.get<OrganizationAttention>(
      `/organizations/${encodeURIComponent(orgId)}/attention`,
    );
    return res.data;
  },
};
